import axios from 'axios';

export const changePassword = (oldPassword, newPassword) => {
  return axios.put('/account/password', {
    oldPassword,
    newPassword,
  });
};
